/**
 * The hold clock: under the checkout's summary, until when the time (or the
 * spot) is held, and two minutes before it runs out a banner offering 15 more
 * minutes (the app's pre-warning).
 */
import { definePiece } from '../../contract/define';

export const contract = definePiece({
  name: 'hold-clock',
  description: 'Until when the chosen time or spot is held, and Keep it for 15 more minutes before it runs out.',
  options: {},
  parts: {
    until: { description: 'Time slot reserved until, or Spot reserved until.', required: true },
    warning: { description: 'Two minutes before it runs out: Keep it, 15 more minutes to finish.', required: true },
  },
  actions: {
    keep: { description: 'Holds the time 15 more minutes.', args: [] },
  },
  events: {},
});

/** What the hold clock knows. */
export interface HoldClockState {
  /** "Time slot reserved until 11:12 AM" (an event: "Spot reserved until 11:12 AM"); null when nothing is held. */
  readonly until: string | null;
  /** True in the last two minutes, while Keep is offered. */
  readonly warning: boolean;
  /** True while Keep is being sent. */
  readonly keeping: boolean;
  /** True when the last Keep did not go through. */
  readonly keepFailed: boolean;
}

/** What a drawing can ask the hold clock to do. */
export interface HoldClockActions {
  /** Hold the time 15 more minutes. */
  readonly keep: () => void;
}

/** What the hold clock tells its host. */
export type HoldClockEvents = Record<string, never>;
